<template>
  <v-dialog v-model="show" width="unset">
    <v-card class="text-left" v-if="design">
      <v-card-title
          class="headline grey lighten-2"
          primary-title
          >
        Información del diseño
      </v-card-title>

      <v-list-item v-for="infoValue in infoValues" :key="infoValue.title">
        <v-list-item-content>
          <v-list-item-title>{{infoValue.title}}</v-list-item-title>
          <v-list-item-subtitle>{{infoValue.value}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Color de junta</v-list-item-title>
          <v-list-item-subtitle>
            <span class="joint-color-sample" :style="{ backgroundColor: design.metadata.jointColorRGB }"></span>
            {{design.metadata.jointColorRGB}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               text
               @click="show = false"
               >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import designService from '../services/design.service';

export default {
  name: 'design-info',
  props: [
    'value',
  ],
  data() {
    return {
      infoValues: [],
      design: null,
      show: this.value,
    };
  },
  watch: {
    value(val) {
      if (!val) {
        return;
      }
      if (this.design !== designService.getCurrentDesign()) {
        this.updateData();
      }
      this.show = true;
    },
    show(val) {
      if (!val) {
        this.$emit('input', false);
      }
    },
  },
  methods: {
    updateData() {
      this.design = designService.getCurrentDesign();
      if (!this.design) {
        this.infoValues = [];
      } else {
        this.infoValues = [
          { title: 'Formato de ficha', value: this.design.tileShapeLabel },
          { title: 'Tamaño en placas (h x v)', value: `${this.design.metadata.hsubmeshes} x ${this.design.metadata.vsubmeshes}` },
          { title: 'Tamaño de placas', value: `${this.design.metadata.htilesPerSubmesh} x ${this.design.metadata.vtilesPerSubmesh}` },
          { title: 'Ancho de junta', value: `${this.design.metadata.jointWidthMM} mm` },
        ];
      }
    },
  },
  created() {
    this.updateData();
  },
}
</script>
